import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { MedicalItemMedicalReaction } from "@/Patient/Models/MedicalSummary/MedicalItemMedicalReaction";
import { MedicalReactionContainer } from "./MedicalReactionContainer";

import styles from "./ClickableMedicalReactionItem.module.scss";

interface IClickableMedicalReactionProps {
    allergies: MedicalItemMedicalReaction[];
    showAllergiesEmptyLabel?: boolean;
    showIntolerancesEmptyLabel?: boolean;
    showReactionsEmptyLabel?: boolean;
    onMedicalItemClick?: (model: MedicalItemMedicalReaction, view: MedicalItemsTab) => void;
    isReadOnly?: boolean;
}

function ClickableMedicalReactionItem(props: IClickableMedicalReactionProps): JSX.Element {
    const allergyTypeLookup = cacheStore.FindLookupByLookupCode("Allergy ");
    const intoleranceTypeLookup = cacheStore.FindLookupByLookupCode("Intolerance");
    const adverseReactionTypeLookup = cacheStore.FindLookupByLookupCode("Adverse Reaction ");

    const allergies = props.allergies.filter(x => x.ReactionTypeLookupId == allergyTypeLookup.LookupID);
    const intolerances = props.allergies.filter(x => x.ReactionTypeLookupId == intoleranceTypeLookup.LookupID);
    const reactions = props.allergies.filter(x => x.ReactionTypeLookupId == adverseReactionTypeLookup.LookupID);

    return (
        <div className={props.isReadOnly ? styles.isReadOnly : ""}>
            <MedicalReactionContainer
                key="medicalNote-allergies"
                medicalReactions={allergies}
                circleName="A"
                circleClassName="circle-red"
                dataCy="medicalNote-allergies"
                onMedicalItemClick={(model: MedicalItemMedicalReaction, view: MedicalItemsTab) =>
                    props.onMedicalItemClick?.(model, view)
                }
                showEmptyLabel={props.showAllergiesEmptyLabel}
            />
            <MedicalReactionContainer
                key="medicalNote-intolerances"
                medicalReactions={intolerances}
                circleName="I"
                circleClassName="circle-grayblue"
                dataCy="medicalNote-intolerances"
                onMedicalItemClick={(model: MedicalItemMedicalReaction, view: MedicalItemsTab) =>
                    props.onMedicalItemClick?.(model, view)
                }
                showEmptyLabel={props.showIntolerancesEmptyLabel}
            />
            <MedicalReactionContainer
                key="medicalNote-reactions"
                medicalReactions={reactions}
                circleName="R"
                circleClassName="circle-gray"
                dataCy="medicalNote-reactions"
                onMedicalItemClick={(model: MedicalItemMedicalReaction, view: MedicalItemsTab) =>
                    props.onMedicalItemClick?.(model, view)
                }
                showEmptyLabel={props.showReactionsEmptyLabel}
            />
        </div>
    );
}

export { ClickableMedicalReactionItem };
